import React, { useState } from "react";
import { Video } from "~/common/Store/models/Video";
import ZestVideoPlayer from "~/common/videoPlayer/ZestVideoPlayer";
interface Props {
  videos: Video[];
  autoPlayOnVideoSwap: boolean;
}
const buttonOptionsList = ["About", "Transcript", "Embed"];
const VideoSpotlight = ({
  videos,
  autoPlayOnVideoSwap
}: Props) => {
  const [autoPlayVideo, setAutoPlayVideo] = useState(false);
  const [selectedVideoIndex, setSelectedVideoIndex] = useState(0);
  const [selectedButton, setSelectedButton] = useState(buttonOptionsList[0]);
  const selectedVideo = videos[selectedVideoIndex];
  const setSelectedVideo = (videoIndex: number) => {
    setSelectedVideoIndex(videoIndex);
    if (autoPlayOnVideoSwap) {
      setAutoPlayVideo(true);
    }
  };
  return <div className="video feature" data-sentry-component="VideoSpotlight" data-sentry-source-file="VideoSpotlight.tsx">
      <div>
        {videos?.length > 0 && selectedVideo !== undefined && <div id={`vid${selectedVideo.id}`} className={`vid${selectedVideoIndex} video-container`}>
            <ZestVideoPlayer key={`videoSpotlightPlayer-${selectedVideo.id}`} videoSection="Regular" data-testid={`videoSpotlightPlayer-${selectedVideo.id}`} posterImage={selectedVideo.poster} sources={selectedVideo.sources} currentIndex={0} selected={0} activePlayer={false} youtubeId={selectedVideo.youtubeId} closedCaptionsrc={selectedVideo.closedCaptionFile} title={selectedVideo.title} autoPlay={autoPlayVideo} playsInline />
            <p className="header-3" style={{
          marginTop: "15px"
        }}>
              <a href={selectedVideo.seoUrl} data-testid={`videoSpotlightLink-${selectedVideo.id}`} target="video" className="video-link media-card__link">
                {selectedVideo.title}
              </a>
            </p>
            <div className="btn-group">
              {buttonOptionsList.map(button => <button key={button} type="button" className={`btn btn-mini btn-light border-gray-400 hover:bg-gray-50 ${selectedButton === button ? "topper-active" : ""}`} style={{
            marginRight: "0px"
          }} onClick={() => setSelectedButton(button)}>
                  {button}
                </button>)}
            </div>
            <div className="clearfix" />
            <div>
              {selectedButton === "About" && <div className="about">
                  <p dangerouslySetInnerHTML={{
              __html: selectedVideo.description || ""
            }} />
                </div>}
              {selectedButton === "Transcript" && <div className="transcript">
                  {selectedVideo.transcript ? <p dangerouslySetInnerHTML={{
              __html: selectedVideo.transcript || ""
            }} /> : "No Video Transcript entered."}
                </div>}
              {selectedButton === "Embed" && <div className="embed">
                  <textarea className="EmbedInfo" value={`<div><iframe scrolling="no" width="392" height="226" src="https://www.webstaurantstore.com/v/?num=${selectedVideo.id}&embed=1" frameBorder="0"></iframe>Courtesy of <a href="https://www.webstaurantstore.com">WebstaurantStore Restaurant Supplies</a></div>`} />
                  <br />
                  <i>Copy and paste the embed code above.</i>
                </div>}
            </div>
          </div>}
      </div>
      {videos?.length > 1 && <div className="resources">
          <p className="header-4">More Videos</p>
          {videos.map((video, index) => <div className="item vid-item" key={video.id}>
              <i className="icon-video" />
              <a className="description" href={`#${video.id}`} onClick={() => setSelectedVideo(index)}>
                {video.title}
              </a>
            </div>)}
        </div>}
    </div>;
};
export default VideoSpotlight;